module.exports = __webpack_public_path__ + "05c455c9fa9cf3609185d19da96d64e9.svg";


//////////////////
// WEBPACK FOOTER
// ./res/images/svgExcludeInline/close.svg
// module id = 419
// module chunks = 0